// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__ks9gf","input_checkbox":"checkbox_input_checkbox__2FT9h","label_checkbox":"checkbox_label_checkbox__xr+Lb"};